// Pagination Bullet Helpers
export function handleSwiperBullets(slider) {
  slider.pagination.bullets.forEach((bullet, index) => {
    if (index < slider.activeIndex) {
      fillBulletProgress(bullet);
    } else {
      resetBulletProgress(bullet);
    }
  });
}
export function handleSwiperBulletsNoAutoplay(slider) {
  slider.pagination.bullets.forEach((bullet, index) => {
    if (index <= slider.activeIndex) {
      fillBulletProgress(bullet);
    } else {
      resetBulletProgress(bullet);
    }
  });
}
function fillBulletProgress(bullet) {
  const progressBar = bullet.querySelector('.bullet-progress');
  progressBar.style.width = '100%';
}
function resetAllBulletProgress(slider) {
  slider.pagination.bullets.forEach((bullet) => {
    resetBulletProgress(bullet);
  });
}
function resetBulletProgress(bullet) {
  const progressBar = bullet.querySelector('.bullet-progress');
  progressBar.style.width = '0%';
}
export function autoPlayValueToPercentage(value) {
  // Clamp the value between 1 and 0
  value = Math.max(0, Math.min(1, value));
  // Calculate the percentage
  const percentage = (1 - value) * 100;
  return percentage;
}
export function handleAutoplayBullettProgress(
  slider,
  percentage,
  prevPercentage
) {
  const activeBullet = slider.pagination.bullets[slider.activeIndex];
  if (activeBullet) {
    const activeProgressBar = activeBullet.querySelector(
      '.bullet-progress'
    );
    const widthValue = autoPlayValueToPercentage(percentage);
    if (percentage === prevPercentage) {
      activeProgressBar.style.width = '0%';
    } else {
      activeProgressBar.style.width = `${widthValue}%`;
    }
    prevPercentage = percentage;
  }
}
